import { render, staticRenderFns } from "./OtpDevice.vue?vue&type=template&id=40855322"
import script from "./OtpDevice.vue?vue&type=script&lang=js"
export * from "./OtpDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports